module.exports = __webpack_public_path__ + "img/foreplay-logo.0aaa3d1f.png";